<script>
	// From Lucide
	import { ChevronUp } from 'lucide-svelte';

	export let iconClass = '';
</script>

<ChevronUp class={iconClass} />
